export default "__VITE_ASSET__DqrSWaTm__"